import React from "react";
import "../App.css";
const Aboutme = () => {
  return (
    <>
      <div className="aboutm">
        <div className="content">
          <ul className="kkkl">
            <li className="hop">
              My Name is <br /> Apar Vipulkumar Solanki
            </li>
            <li className="cur">
              ~ 🤔 Currently I'm studing Information Technology
              <br />~ 💬 In Dharmsinh Desai University
            </li>
            <li className="ilik">
              ~ 👀 I’m interested in technology and learning new technical
              skills. <br />~ 👯 I Like To Explore New Things In Technology,
              Business And Travel.
            </li>

            <li className="fou">
              ~ 🌱 I’m currently improving my competitive programming.
              <br /> ~ 📫 I'm MERN full stack developer otherthan that i do
              coding in c++ and also advance and core java. <br /> ~ 🤔 Good
              grip in OS , DBMS , CCN , OOP concepts. <br /> ~ 😄 Excellent in
              problem solving at various platforms like leetcode , codechef and
              hackerrank.
              <br />~ 👯 Other than technical knowledge i am also good at
              building network <br />~ 🌱 And lead the team as i have
              participated in 5+ hackathons and won in 3+ out of them at various
              levels
            </li>

            <li className="coll">~ ⚡ Focusing on College Subjects as well</li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Aboutme;
